import { isPageEmbedded } from './is-page-embedded';

type EmbedWindow = Pick<Window, 'parent' | 'requestAnimationFrame'>;

type EmbedDocument = Pick<Document, 'body' | 'documentElement'>;

type ResizeObserverConstructor = new (callback: ResizeObserverCallback) => ResizeObserver;

type EmbedHeightMessengerOptions = {
  document?: EmbedDocument;
  resizeObserver?: ResizeObserverConstructor;
  window?: EmbedWindow;
};

export function initializeEmbedHeightMessenger({
  document: targetDocument = document,
  resizeObserver: ResizeObserverType = ResizeObserver,
  window: targetWindow = window
}: EmbedHeightMessengerOptions = {}): void {
  if (!isPageEmbedded(targetDocument) || targetWindow.parent === targetWindow) {
    return;
  }

  let lastHeight = -1;
  let animationFramePending = false;

  const sendHeight = () => {
    animationFramePending = false;

    const height = Math.round(targetDocument.body.scrollHeight);
    if (height === lastHeight) return;

    lastHeight = height;
    targetWindow.parent.postMessage(height, '*');
  };

  const scheduleHeight = () => {
    if (animationFramePending) return;

    animationFramePending = true;
    targetWindow.requestAnimationFrame(sendHeight);
  };

  const resizeObserver = new ResizeObserverType(scheduleHeight);
  resizeObserver.observe(targetDocument.body);

  scheduleHeight();
}
